<script>
import LegalEntitiesForm from './LegalEntitiesForm'

export default {
  extends: LegalEntitiesForm,

  methods: {
    onSubmit() {
      this.createLegalEntity(this.form)
        .then(() => {
          this.successSubmit({ message: 'Юр. лицо успешно создано', routeName: 'legal-entities' })
        })
        .finally(() => { this.afterSubmit() })
    }
  }
}
</script>